// extracted by mini-css-extract-plugin
module.exports =  {"label":"qSwIwaDIy1Tqg6JyOQLf"};